import React from "react";
import {
	useLocation,
	useNavigationType,
	createRoutesFromChildren,
	matchRoutes,
} from "react-router-dom";
import * as Sentry from "@sentry/react";

import { ENVIRONMENT, isDevelopment } from "@/utils/environment";

Sentry.init({
	dsn: import.meta.env.VITE_APP_SENTRY_DSN,
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	integrations: [
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
	],
	// Enable logs to be sent to Sentry
	enableLogs: true,
	environment: ENVIRONMENT,
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// Learn more at
	// https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
	tracesSampleRate: isDevelopment ? 0.1 : 0.5,
	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
	tracePropagationTargets: [
		/^https:\/\/laladrillera-eus2\.azurewebsites\.net\/graphql/,
	],
	release: "toma-pedidos@" + import.meta.env.VITE_APP_RELEASE_VERSION,
});
